import { useState, useEffect } from "react";
import AudioPlayer from "react-h5-audio-player";
// import download from "downloadjs";
// import { GridLoader as Spin } from "react-spinners";
// import synthCall from "../../utils/modelUtils/tacoSynthCaller";
// import News from "../../assets/Media/News/news1.wav";
import Rec from "../../assets/Media/Recommended/rec1.wav";
import Rec1 from "../../assets/Media/Recommended/rec2.mp3";
import Rec2 from "../../assets/Media/Recommended/rec3.mp3";
import Rec3 from "../../assets/Media/Recommended/rec4.wav";
import Sport from "../../assets/Media/Sports/sport.wav";
import Sport2 from "../../assets/Media/Sports/sport2.wav";
import Sport3 from "../../assets/Media/Sports/sport3.wav";
import Sport4 from "../../assets/Media/Sports/sport4.wav";
import Tech from "../../assets/Media/Tech/tech1.wav";
import Book from "../../assets/Media/Book/book.wav";
import "react-h5-audio-player/lib/styles.css";
import "./mediaControl.styles.scss";

const MediaControl = (props) => {
  const [audioSrc, setAudioSrc] = useState(Rec);
  useEffect(() => {
    if (props.mediaUrl === "news") {
      setAudioSrc(Rec); // another dirty hack cause deleted the audio file
    } else if (props.mediaUrl === "rec") {
      setAudioSrc(Rec);
    }else if (props.mediaUrl === "rec1") {
      setAudioSrc(Rec1);
    }
    else if (props.mediaUrl === "rec2") {
      setAudioSrc(Rec2);
    }
    else if (props.mediaUrl === "rec3") {
      setAudioSrc(Rec3);
    }
     else if (props.mediaUrl === "tech") {
      setAudioSrc(Tech);
    } else if (props.mediaUrl === "sport") {
      setAudioSrc(Sport);
    }else if (props.mediaUrl === "sport2") {
      setAudioSrc(Sport2);
    }
    else if (props.mediaUrl === "sport3") {
      setAudioSrc(Sport3);
    }
    else if (props.mediaUrl === "sport4") {
      setAudioSrc(Sport4);
    }
    else if (props.mediaUrl === "book") {
      setAudioSrc(Book);
    }
  }, [props]);
  // console.log(props)
  // const [audios, setAudio] = useState("");
  // let [loading, setLoading] = useState(false);
  // let setDataNew = (data) =>

  // let text = `${props.text}`;

  // useMemo(() => {
  //   if (text !== "") {
  //     fetchData(text)
  //       .then((response) => {
  //         // response.value for fetch streams is a Uint8Array
  //         // var blob = new Blob([response.value], { type: "audio/wav" });
  //         var url = URL.createObjectURL(response);
  //         // setLoading(false);
  //         setAudio(url);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }, [text]);

  // const dataNew = useMemo(() => {text: `${props.text}`});

  // console.log("PROPS", props);
  // console.log("DATA NEW", text);

  // console.log("AUDIOS", audios);

  // return audios ? (
  //   <AudioPlayer
  //     className="audio-player"
  //     autoPlay={false}
  //     src={props.mediaUrl}
  //     onPlay={(e) => console.log("Playing Audio")}
  //   />
  // ) : (
  //   <AudioPlayer className="audio-player" autoplay={false} src={props.mediaUrl} />
  // );

  // tmp fix

  return (
    <AudioPlayer
      className="audio-player"
      autoPlay={false}
      src={audioSrc}
      onPlay={(e) => console.log("Playing Audio")}
    />
  );

  // <audio src={audios} autoPlay controls></audio>
};

// async function fetchData(text) {
//   console.log("USE EFFECT CALL");
//   return fetch("https://f964cdd07e33.ngrok.io/read", {
//     // mode: "no-cors",
//     method: "post",
//     body: JSON.stringify({ text }),
//     headers: {
//       Accept: "application/json, text/plain, */*",
//       "Content-Type": "application/json",
//     },
//   }).then((res) => {
//     console.log(res);
//     // setLoading(true);
//     // console.log("SET Loading set to true");

//     if (!res.ok) {
//       throw new Error(`${res.status} = ${res.statusText}`);
//     }
//     // response.body is a readable stream.
//     // Calling getReader() gives us exclusive access to
//     // the stream's content
//     var reader = res.blob();
//     return reader;
//   });
// }

export default MediaControl;
